import React from "react";
import Tools from './utils/Tools';
import $ from 'jquery';
var strings = Tools.getStrings();

export default class WPProduct extends React.Component {
    constructor(props) {
        super(props);

        $('.loadingContainerv2').hide();
        let ls = window.location.href.split('/info/');
        ls = ls[1].split('/');
        this.state = {
            product: {name: "", image:{url:""}, shouldhave:[], price:0},
            original: {name: "", image:{url:""}, shouldhave:[], price:0},
            url: "",
            type: ls[0],
            step: 0,
            addextras: false,
            isLogged: false,
            activeSize: "",
            collections: [],
            priceRulesDiscount: 0,
            totalCalc: 0,
            quantityerrorComp: false,
            quantityerrorCompMsg: ""
        };
    }

    componentWillMount() {
        let ls = window.location.href.split('/info/');
        ls = ls[1].split('/');
        window.WebApp.getInfo().getProductWithPrices(ls[0], ls[1], (result) => {
            this.setState({
                product: result.product,
                original: result.product,
                url: result.frontoffice_url,
            }, () => this.setProduct());
        });
    }

    setProduct() {
        $('.loadingContainerv2').hide();
        let product = this.state.product;
        product.quantity = 1;

        if(product.shouldhave !== undefined && product.shouldhave.length > 0) {
            product.original_price = product.price;
            for(var i = 0; i < product.shouldhave.length; i++) {
                for(var j = 0; j < product.shouldhave[i].products_filtered.length; j++) {
                    let prod = product.shouldhave[i].products_filtered[j];
                    for(var k = 0; k < prod.included; k++) {
                        this.addComposition(i,j,false);
                    }
                }
            }
        }
        this.setState({
            product
        });
    }

    addComposition(compIndex, prodIndex, increment) {
        let product = this.state.product;
        let result = window.WebApp.getCart().addComposition(product,compIndex,prodIndex);
        if(result.success) {
            let prodToAdd = product.shouldhave[compIndex].products_filtered[prodIndex];
            if(product.shouldhave[compIndex].pivot.max_quantity === 1) {
                for(var i = 0; i < product.shouldhave[compIndex].products_filtered.length; i++) {
                    product.shouldhave[compIndex].products_filtered[i].included = 0;
                }
            }
            if(increment) {
                prodToAdd.included++;
                product.shouldhave[compIndex].countIncluded++;
            }

            this.setState({
                product: result.product,
            }, () => this.calcPrice(compIndex,prodIndex));
        }
    }

    lessComposition(compIndex, prodIndex) {
        var product = this.state.product;
        if(product.shouldhave[compIndex].products_filtered[prodIndex].included > 0) {
            var result = window.WebApp.getCart().lessComposition(product,compIndex,prodIndex,'allow0');
            result.product.shouldhave[compIndex].products_filtered[prodIndex].included--;
            this.setState({
                product: result.product
            }, () => this.calcPrice(compIndex,prodIndex));
        }
    }

    calcPrice(compIndex, prodIndex) {
        window.WebApp.getNetwork().getLoading().doNotLoad(-1);
        var product = this.state.product;
        var compProds = [];
        if(product.composition !== undefined) {
            compProds = product.composition.products
        }
        let quantity = product.quantity !== undefined && product.quantity !== 0 ? product.quantity : 1;
        var toCalc = {id:product.id, name:product.name, quantity: quantity, composition:{products:compProds}};
        var data = {extras:[toCalc]};
        if(this.state.type === "menu"){
            data = {menus:[toCalc]};
        }
        let newTotal = 0;
        let totalCalc = 0;
        let priceRulesDiscount = 0;
        window.WebApp.getCheckout().calculatePrice(data, (result) => {
            if(this.state.type === "menu"){
                newTotal = result.menusInfo.prices[0].price;
            }else {
                newTotal = result.extrasInfo.prices[0].price;
            }
            if(compIndex !== undefined && prodIndex !== undefined) {
                product = window.WebApp.getCart().priceForComposition(product.price,newTotal,product,compIndex,prodIndex);
            }
            product.price = newTotal;
            totalCalc = product.price * product.quantity;
            priceRulesDiscount = result.menusInfo.priceRulesDiscount + result.extrasInfo.priceRulesDiscount;
            totalCalc -= priceRulesDiscount;
            this.setState({
                product,
                totalCalc,

            });
        });
    }

    createMarkup(text) {
        return {__html: text};
    }

    toggleComp(compIndex) {
        let product = this.state.product;
        let issame = false;
        if(product.shouldhave[compIndex].opened) {
            $('.comp-products').hide();
            issame = true;
        } else {
            $('.comp-products').hide();
            $('.comp-products-'+compIndex).css({'display':'flex'});
        }
        
        for(var i = 0; i < product.shouldhave.length; i++) {
            product.shouldhave[i].opened = false;
        }
        if(!issame) {
            product.shouldhave[compIndex].opened = true;
        }
        this.setState({
            product
        });
    }

    moreProduct() {
        let product = this.state.product;
        if(product.quantity === undefined) product.quantity = 1;
        product.quantity += product.increment_quantity;
        this.setState({
            product
        }, () => this.calcPrice());
    }

    lessProduct() {
        let product = this.state.product;
        if(product.quantity > 1) {
            product.quantity -= product.increment_quantity;
            this.setState({
                product
            }, () => this.calcPrice());
        }
    }

    changeComposition(e, compIndex) {
        this.addComposition(compIndex, e.target.value);
    }

    add() {
        let product = this.state.product;
        
        let validated = "";
        let compStep = "";
        for(var i = 0; i < product.shouldhave.length; i++) {
            if(product.shouldhave[i].pivot.min_quantity != 0) {
                if(product.composition == undefined || product.composition.quantities == undefined) {
                    validated = product.shouldhave[i].pivot.min_quantity;
                    compStep = i+1;
                    break;
                }
                if(product.composition.quantities[i] == undefined || product.composition.quantities[i] < product.shouldhave[i].pivot.min_quantity) {
                    validated = product.shouldhave[i].pivot.min_quantity;
                    compStep = i+1;
                    break;
                }
            }
        }
        if(validated != "") {
            this.setState({
                quantityerrorComp: true,
                quantityerrorCompMsg: "Selecione pelo menos "+validated+" no "+compStep+"º passo",
            });
        } else {
            if(product.quantity === undefined || product.quantity === 0) {
                product.quantityerror = true;
                this.setState({
                    product,
                    quantityerrorComp: false
                });
            } else {
                window.WebApp.getCart().addExtra(product, () => {
                    localStorage.setItem('added_product', product.name);
                    window.location.href="/loja";
                });
            }
        }
    }

    prodHasQuant(productId) {
		if(this.state.product.composition === undefined || this.state.product.composition.products === undefined) {
			return false;
		}
        for(var i = 0; i < this.state.product.composition.products.length; i++) {
            if(this.state.product.composition.products[i].id === productId){
                return this.state.product.composition.products[i].quantity > 0;
            }
        }
        return false;
    }

    checkComposition(compIndex, prodIndex, deselect) {
		var product = this.state.product;
        var prodToAdd = product.shouldhave[compIndex].products_filtered[prodIndex];
        if(deselect !== undefined && prodToAdd.included === 1 && product.shouldhave[compIndex].pivot.max_quantity === 1) {
            return;
        }
        let result = null;
        if(prodToAdd.included > 0 && product.shouldhave[compIndex].pivot.max_quantity === 1) {
            result = window.WebApp.getCart().lessComposition(product,compIndex,prodIndex,'allow0');
            prodToAdd.included = 0;
            this.setState({
                product:result.product,
                hasAcomp: false
            }, () => this.calcPrice(compIndex,prodIndex));
        }else {
            result = window.WebApp.getCart().addComposition(product,compIndex,prodIndex);
            if(result.success) {
                if(product.shouldhave[compIndex].pivot.max_quantity === 1) {
                    for(var i = 0; i < product.shouldhave[compIndex].products_filtered.length; i++) {
                        product.shouldhave[compIndex].products_filtered[i].included = 0;
                    }
                }
                prodToAdd.included++;

                this.setState({
                    product:result.product,
                    hasAcomp: true,
                }, () => this.calcPrice(compIndex,prodIndex));
            }
        }
    }

    render() {
        let prodname = this.state.product.name;
        return (
            <div>
                <div className="finalize-snackbar">
                    <div className="main-container flex between">
                        <h5 className="white">{strings.added1} <span className="prodname"></span> {strings.added2} <span className="pointer underline" onClick={() => window.location.href="/checkout"}>{strings.added3}</span></h5>
                        <img alt="fechar-carrinho" src={window.fechar} onClick={() => $('.finalize-snackbar').stop().slideUp()}/>
                    </div>
                </div>
                <div className="product-page header-padding">
                    <div className="main-container">
                        <div className="flex center">
                            <div className="sides image flex1" style={{backgroundImage:(this.state.product.image !== null ? 'url('+this.state.url+this.state.product.image.url+')' : 'url('+window.placeholder+')')}}></div>
                            <div className="sides flex1">
                                <h2 className="green">{prodname}</h2>
                                <div className="description" dangerouslySetInnerHTML={this.createMarkup(this.state.product.description)} />
                                <p className="black f700">€{this.state.product.price.toFixed(2)}</p>
                            </div>
                        </div>
                        {this.state.product.shouldhave.length > 0 &&
                            <div style={{maxWidth:"766px", marginBottom:"30px", margin:"0 auto"}}>
                                <h3 className="f700 green">Personalize o seu pedido:</h3>
                                {this.state.product.shouldhave.map((composition, compIndex) => {
                                    if(composition.pivot.max_quantity === 1) {
                                        return (
                                            <div key={compIndex}>
                                                <p className="f700 green" style={{marginBottom:"20px", marginTop:"30px"}}>{composition.pivot.description}</p>
                                                <div className="flex start align-center">
                                                    {composition.products_filtered.map((prod, index2) => {
                                                        let split = prod.name.split(' (');
                                                        let price = "";
                                                        if(split.length > 1 && split[1].indexOf('€') > -1) {
                                                            price = split[1].replace(')', "");
                                                        }
                                                        return (
                                                            <div key={index2} className="checkbox-wrap flex between" style={{width:"345px", marginBottom:"15px"}}>
                                                                {/* <div className={"checkbox" + (this.prodHasQuant(prod.id) ? " active" : "")} */}
                                                                <div className={"checkbox" + (prod.included == 1 ? " active" : "")}
                                                                    onClick={() => this.checkComposition(compIndex,index2)}>
                                                                </div>
                                                                <div onClick={() => this.checkComposition(compIndex,index2)} style={{flex:1, marginLeft: "20px"}}>
                                                                    <p className="pointer">{price !== "" ? split[0] : prod.name}</p>
                                                                    {price !== "" && <p className="green">+{price}</p>}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        )
                                    }
                                    return (
                                        <div key={compIndex}>
                                            <p className="f700 green"  style={{marginBottom:"20px", marginTop:"30px"}}>{composition.pivot.description}</p>
                                            <div className="flex start">
                                                {composition.products_filtered.map((prod, index2) => {
                                                    return (
                                                    <div className="flex between align-center" style={{width:"345px", marginBottom:"15px"}} key={compIndex+""+index2}>
                                                        <div className="flex between quantities" style={{width:"100px", marginRight:"5px"}}>
                                                            <img style={prod.included === 0 ? {opacity:"0.6",cursor:"default"} : {}} src={window.menos}
                                                                onClick={() => this.lessComposition(compIndex, index2)} alt="menos"/>
                                                            <h4 className="flex1 center-text">{prod.included}</h4>
                                                            <img src={window.mais} style={this.state.product.composition !== undefined && this.state.product.composition.quantities[compIndex] === composition.pivot.max_quantity ? {opacity: 0.5} : {}} onClick={() => this.addComposition(compIndex, index2, true)} alt="mais"/>
                                                        </div>
                                                        <div className="flex1">
                                                            <p style={{marginBottom:"0px"}}>{prod.name}</p>
                                                            {prod.compPrice !== undefined && prod.compPrice > 0 &&
                                                                <p style={{marginBottom:"0px"}} className="green">+ €{prod.compPrice.toFixed(2)}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        {this.state.product.quantityerror &&
                            <h6 className="center-text" style={{color:"red", marginBottom:"5px", marginTop:"0px"}}>* {strings.selectqty}</h6>
                        }
                        {this.state.quantityerrorComp &&
                            <h6 className="center-text" style={{color:"red", marginBottom:"5px", marginTop:"0px"}}>* {this.state.quantityerrorCompMsg}</h6>
                        }
                        <div className="flex center" style={{marginTop:"30px", marginBottom:"30px"}}>
                            <div className="flex between quantities">
                                <img className="pointer" alt="menos" src={window.menos} onClick={() => this.lessProduct()}/>
                                <h4 className="green">{this.state.product.quantity === undefined ? 1 : this.state.product.quantity}</h4>
                                <img className="pointer" alt="mais" src={window.mais} onClick={() => this.moreProduct()}/>
                            </div>
                            <button className="white-btn flex1" style={{maxWidth:"200px", marginLeft:"20px", textTransform:"uppercase"}} onClick={() => this.add()}>
                                {strings.order}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
